module.exports = __webpack_public_path__ + "static/media/hudsonRiverTrading.5ebed5df.png";